import { render } from "./eb-selector.vue?vue&type=template&id=4aa1aaf8"
import script from "./eb-selector.vue?vue&type=script&lang=ts"
export * from "./eb-selector.vue?vue&type=script&lang=ts"
script.render = render

export default script